import React, { useEffect, useState } from 'react';

import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core';

import GeneralDataTable from '../core/GeneralDataTable/GeneralDataTable';
import Octagon from '../core/Octagon';
import Toolbar from '../core/Toolbar';
import { notificationDialogSeverity } from '../core/Constants';

import { colors } from '../theme';
import { users } from '../api';

import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { showNotificationDialog } from '../app/AppActions';

import moment from 'moment';
import { startCase } from 'lodash';


//////////////////////////////////////////////////////////////////////////////


const SuperadminLogsPasswordResets = (props) => {
    const { reduxDispatch, classes } = props;


    // State for the password reset data
    const [resets, setResets] = useState([]);

    // State-object for table pagination
    const [paginationState, setPaginationState] = useState({
        rowsPerPage: 25,
        page: 0,
    });

    // State-object for table column sorting
    const [columnSortingOptions, setColumnSortingOptions] = useState({
        direction: 'desc',
        column: 'createdAt'
    })


    /**
     * Fetch data using paginationState information
     */
    useEffect(() => {
        const order = columnSortingOptions.direction === 'desc' ? -1 : 0 ;
        const orderObj = {}
        orderObj[columnSortingOptions.column] = order;

        users.findResetRequests({
                $sort: orderObj,
                $limit: paginationState.rowsPerPage,
                $skip: paginationState.rowsPerPage * paginationState.page
            })
            .then(res => {
                setResets(res);
            })
            .catch((err) => {
                reduxDispatch.showMessage(err.message, 'Error', notificationDialogSeverity.error)
            })
    }, [
        paginationState.rowsPerPage,
        paginationState.page,
        columnSortingOptions.direction,
        columnSortingOptions.column,
        reduxDispatch
    ])


    // Table columns
    const columns = [
        { label: 'Email', field: 'email', sortable: true },
        { label: 'Used', field: 'used', conversion: value => startCase(value.toString()), sortable: true },
        { label: 'Created', field: 'createdAt', conversion: date => moment(date).format('DD.MM.YYYY HH:mm:ss'), sortable: true },
        { label: 'Expires', field: 'expiresAt', conversion: date => moment(date).format('DD.MM.YYYY HH:mm:ss'), sortable: true }
    ];


//////////////////////////////////////////////////////////////////////////////


    return (
        <Octagon w='80rem' color={colors.octagon}>
            <Toolbar title='Password Resets' onGoBack={() => browserHistory.push('/admin/logs')} />
            <Paper className={classes.table} elevation={4}>
                <GeneralDataTable
                    columns={columns}
                    data={resets}
                    dense
                    columnSortingOptions={columnSortingOptions}
                    onChangeColumnSortingOptions={(newOptions) => setColumnSortingOptions(newOptions)}
                    paginationState={paginationState}
                    onChangePagination={(state) => setPaginationState(state)}
                />
            </Paper>
        </Octagon>
    )
}


//////////////////////////////////////////////////////////////////////////////


const mapStateToProps = (state) => ({
    reduxState: {}
});


const mapDispatchToProps = (dispatch) => ({
    reduxDispatch: {
        showMessage: (message, title, severity) => {
            dispatch(showNotificationDialog(message, title, severity))
        }
    }
})


const styles = theme => ({
    table: theme.containers.dataTable
})


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SuperadminLogsPasswordResets))
